(function () {
  'use strict'

  require('./api')

  var MODULE_NAME = 'thismoment.api'

  angular
    .module(MODULE_NAME, [
      'thismoment.api.core'
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/api/index.js